import React, { useState, useEffect } from 'react';
import { View, Text, Pressable } from 'react-native';
import Input from '../../elements/inputs';

const CustomLocation = (props) => {
  const { setShowCustomLocationFields, control, errors } = props;
  return (
    <View
      style={{
        border: 'solid 1px black',
        borderRadius: '5px',
        padding: '10px'
      }}
    >
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <Text style={{fontSize: '16px'}}>
          Location:
        </Text>
      </View>
      <br/>
      <Input.Text
        label="Street:"
        name="street"
        control={control}
      />
      <Input.Text
        label="City:"
        name="city"
        control={control}
      />
      <Input.StatePicker
        label="State:"
        name="state"
        control={control}
        errors={errors}
      />
      <Input.Text
        label="Zip:"
        name="postalCode"
        control={control}
      />
    </View>
  )
}

export default CustomLocation;